import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const ContactModuleAnimation = () => {
  const containers = document.querySelectorAll(".contact-module");
  if (containers.length < 1) {
    return;
  }

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (reduceMotion) return;

  const base = {
    y: 0,
    opacity: 1,
    duration: 1,
    ease: "power2.inOut",
  };
  const applyAnimations = () => {
    containers.forEach((container) => {
      const headline = container.querySelectorAll(".contact-module__headline");
      const subline = container.querySelectorAll(".contact-module__subline");
      const form = container.querySelectorAll(".contact-module__shortcode");

      if (!headline.length && !subline.length && !form.length) return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: "top 80%",
          once: true,
          fastScrollEnd: true,
        },
      });

      if (headline.length) {
        tl.to(headline, base, 0);
      }

      if (subline.length) {
        tl.to(subline, base, 0.2);
      }

      if (form.length) {
        tl.to(form, base, 0.4);
      }
    });
  };
  applyAnimations();
};

export default ContactModuleAnimation;
